import React from "react";
import { Spinner } from "@fluentui/react-components";

const Spin = ({ label = "Loading..", FullScreenSpin }) => {
  return (
    <div className="d-flex align-items-center justify-content-center gap-2">
      <Spinner
        className={FullScreenSpin ? "FullScreenSpin" : "spinWrapper"}
        size={FullScreenSpin ? "large" : "medium"}
        label={label}
        labelPosition="right"
      />
      <p>{label}</p>
    </div>
  );
};

export default Spin;
